<template>
  <div id="page-top">
    <header class="header-mobile"></header>

    <header class="header header-desktop">
      <div class="container h-100">
        <div class="row h-100 align-items-center">
          <div class="col-md-6">
            <h1>
              <strong>Resimple</strong> es la nueva forma de comprar y cobrar que todos están eligiendo.
            </h1>

            <!-- <ul class="nunito mt-4">
              <li class="item-1">
                <a href="#enviar-dinero" class="scroll-link">Envía o recibí dinero.</a>
              </li>
              <li class="item-2">
                <a href="#recargas" class="scroll-link">Realizá recargas.</a>
              </li>
              <li class="item-3">
                <a href="#impuestos" class="scroll-link">Pagá impuestos y servicios.</a>
              </li>
              <li class="item-4">
                <a href="#pago-comercios" class="scroll-link">Comprá en comercios.</a>
              </li>
              <li class="item-1">
                <a href="#pago-comercios" class="scroll-link">Retirá efectivo.</a>
              </li>
            </ul> -->
          </div>
        </div>
      </div>
                 <div style="font-size:10px;  position: fixed;
            bottom: 0; padding:10px">RESIMPLE ofrece servicios de pago y no es una entidad financiera ni se encuentra
autorizado a operar como entidad financiera por el Banco Central de la República
Argentina. RESIMPLE no presta al Usuario ningún servicio bancario o cambiario. Los
fondos depositados en la cuenta de pago no constituyen depósitos en una entidad
financiera, ni cuentan con ninguna de las garantías que tales depósitos puedan gozar
de acuerdo con la legislación y reglamentación aplicables en materia de depósitos de
entidades financieras.</div>
    </header>

    <!-- <section class="intro py-5" id="about">
      <div class="container py-md-5">
        <h1 class="text-center mb-4">
          <strong class="nunito color-primary">Una app y una tarjeta prepaga que hacen todo Resimple</strong>
        </h1>

        <p>
          <span class="color-primary">Resimple</span> es una plataforma digital de dinero electrónico que brinda una serie de herramientas que facilitan la gestión de la misma, ofreciendo también a los usuarios finales y comercios los medios necesarios para la utilización y participación activa de los servicios brindados.
        </p>

        <div class="row">
          <div class="col-sm-6 text-center col-left">
            <img src="img/portal/img_phone_resimple.png" class="img-fluid" style="width:100%"/>            
          </div>
           <div class="col-sm-6 text-center col-right">
            <img src="img/portal/ic_card_rs_new2.png" class="img-fluid" style="width:100%"/>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 text-center col-left">
            <div class="mt-3">
              <b-dropdown
                text="¿Que puedo hacer con Resimple?"
                class="dropdown-quepuedo"
                id="dropdown-quepuedo"
              >
                <b-dropdown-item class="scroll-link" href="#enviar-dinero">Enviar Dinero</b-dropdown-item>
                <b-dropdown-item class="scroll-link" href="#recargas">Recargas</b-dropdown-item>
                <b-dropdown-item class="scroll-link" href="#impuestos">Pago de Servicios</b-dropdown-item>
                <b-dropdown-item class="scroll-link" href="#pago-comercios">Pago en comercios</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="col-sm-6 text-center col-right">
            <p class="fs-08">
              Tarjeta “MasterCard” Internacional Prepaga.
              <br />Podrás usarla para comprar en comercios de Argentina y del exterior.
              <br />
              <br />
            </p>

            <div class="d-none my-3">
              <a href="#" class="btn btn-transparent-grey">Más info sobre Tarjeta de compra Resimple</a>
            </div>

            <div class="d-none">
              <a href="#" class="btn btn-primary">Solicitá tu tarjeta ahora</a>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section id="enviar-dinero" class="full-height enviar-dinero">
      <div class="container h-100">
        <div class="row h-100 align-items-center">
          <div class="col-md-6">
            <div class="header-icon">
              <img src="img/portal/ic_menu_enviar_dinero.svg" class="icon mb-3" />
            </div>
            <div class="section-content">
              <h1>
                <strong class="nunito color-primary">Enviá o recibí dinero</strong>
              </h1>
              <h2 class="nunito sb color-primary">Se acredita al instante y es totalmente gratis.</h2>
              <p
                class="text-black"
              >Podés retirar el efectivo en más de 40.000 puntos en todo el país.</p>
            </div>
            <a
              href="#mapa-comercios"
              class="btn btn-primary scroll-link"
            >Encontrá tu punto de retiro más cercano</a>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section id="recargas" class="full-height recargas">
      <div class="container h-100">
        <div class="row h-100 align-items-center">
          <div class="col-md-6 offset-md-6 text-right">
            <div class="header-icon right">
              <img src="img/portal/ic_menu_recargas.svg" class="icon mb-0" />
            </div>
            <div class="section-content">
              <h1>
                <strong class="nunito color-primary">Realizá recargas</strong>
              </h1>
              <h2
                class="nunito sb color-primary"
              >Con el saldo de la billetera, podes hacer tus recargas.</h2>
              <p
                class="text-black"
              >Telefonía de todas las compañías y otros servicios prepagos como la tarjeta de SUBE, Direct TV, etc.</p>
              <p>
                <img src="img/portal/brands/personal.png" class="bwbrands" />
                <img src="img/portal/brands/movistar.png" class="bwbrands" />
                <img src="img/portal/brands/claro.png" class="bwbrands" />
                <img src="img/portal/brands/tuenti.png" class="bwbrands" />
                <img src="img/portal/brands/dtv.png" class="bwbrands" />
                <img src="img/portal/brands/sube.png" class="bwbrands" />
              </p>

              <a
                href="#map"
                class="btn btn-transparent-primary scroll-link d-none"
              >Puntos de Cobro cercanos</a>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section id="impuestos" class="full-height pago-impuestos">
      <div class="container h-100">
        <div class="row h-100 align-items-center">
          <div class="col-md-7">
            <div class="header-icon">
              <img src="img/portal/ic_menu_pago_impuesto.svg" class="icon mb-3" />
            </div>

            <div class="section-content">
              <h1>
                <strong class="nunito color-primary">Pagá impuestos y servicios</strong>
              </h1>
              <h2
                class="nunito sb color-primary"
              >Actualmente estamos habilitados para cobrar más de 4.000 impuestos y servicios</h2>
              <p
                class="text-black"
              >Y seguimos sumando acuerdos con diferentes entidades para que puedas pagar todo en un mismo lugar.</p>

              <div class="row fs-08 color-primary">
                <div class="col-sm-6">
                  <ul style="list-style-type:none;">
                    <li class="ListRubros">
                      <img src="img/portal/rubros/elect.png" style="height:20px;margin-top:-5px;" /> Luz
                    </li>
                    <li class="ListRubros">
                      <img src="img/portal/rubros/gas.png" style="height:20px;margin-top:-5px;" /> Gas
                    </li>
                    <li class="ListRubros">
                      <img src="img/portal/rubros/telef.png" style="height:20px;margin-top:-5px;" /> Teléfono
                    </li>
                    <li class="ListRubros">
                      <img src="img/portal/rubros/cable.png" style="height:20px;margin-top:-5px;" /> Cable
                    </li>
                    <li class="ListRubros">
                      <img src="img/portal/rubros/agua.png" style="height:20px;margin-top:-5px;" /> Agua
                    </li>
                    <li class="ListRubros">
                      <img
                        src="img/portal/rubros/internet.png"
                        style="height:20px;margin-top:-5px;"
                      /> Internet
                    </li>
                    <li class="ListRubros">
                      <img src="img/portal/rubros/seguro.png" style="height:20px;margin-top:-5px;" /> Seguros
                    </li>
                  </ul>
                </div>
                <div class="col-sm-6">
                  <ul style="list-style-type:none;">
                    <li class="ListRubros">
                      <img src="img/portal/rubros/educ.png" style="height:20px;margin-top:-5px;" /> Instituciones educativas
                    </li>
                    <li class="ListRubros">
                      <img src="img/portal/rubros/salud.png" style="height:20px;margin-top:-5px;" /> Medicina – Obras sociales
                    </li>
                    <li class="ListRubros">
                      <img src="img/portal/rubros/ahorro.png" style="height:20px;margin-top:-5px;" /> Planes de ahorro
                    </li>
                    <li class="ListRubros">
                      <img src="img/portal/rubros/house.png" style="height:20px;margin-top:-5px;" /> Planes de vivienda
                    </li>
                    <li class="ListRubros">
                      <img src="img/portal/rubros/card.png" style="height:20px;margin-top:-5px;" /> Tarjetas – Financieras
                    </li>
                    <li class="ListRubros">
                      <img src="img/portal/rubros/coop.png" style="height:20px;margin-top:-5px;" /> Cooperativas
                    </li>
                    <li class="ListRubros">Otros</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="input-group mt-3">
              <div class="input-group-prepend">
                <KitsCombo
                  v-model="CategoriaID"
                  v-bind:items="categorias"
                  :cleanDefault="true"
                  propertyName="Name"
                  propertyID="EntityID"
                  :todos="true"
                  id="selectCategorias"
                  nullText="Todas las categorías"
                ></KitsCombo>
              </div>
              <button type="button" class="btn btn-ver-lista" @click="listaClicked">Ver Lista</button>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section id="pago-comercios" class="full-height pago-comercios">
      <div class="container h-100">
        <div class="row h-100 align-items-center">
          <div class="col-md-6 offset-md-6 text-right">
            <div class="header-icon right">
              <img src="img/portal/ic_menu_pago_comercio.svg" class="icon mb-0" />
            </div>
            <div class="section-content">
              <h1>
                <strong class="nunito color-primary">Comprá en comercios</strong>
              </h1>
              <h2 class="nunito sb color-primary">
                <img src="img/portal/qr.png" style="height:20px;margin-top:-3px;" /> Pago con QR desde tu celular
              </h2>
              <p
                class="text-black"
              >Es la nueva forma de comprar que todos están eligiendo. Sólo tenés que acercar tu celular al Código QR del comercio y listo.</p>

              <h2 class="nunito sb color-primary">
                <img src="img/portal/retiro.png" style="height:24px;margin-top:-3px;" /> Retirá dinero en efectivo en el acto y sin costo
              </h2>
              <p
                class="text-black"
              >Con Resimple no necesitás pasar por un cajero automático para obtener efectivo. Los comercios adheridos ofrecen la posibilidad de extraer dinero con tu tarjeta de débito, o con saldo de tu billetera.</p>              

              <a href="#mapa-comercios" class="btn btn-primary scroll-link">Ver comercios cercanos</a>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section class="mapa position-relative" id="mapa-comercios">
      <div class="controles">
        <div class="row px-1 px-lg-5">
          <div class="col-sm-6 col-lg-3"></div>
        </div>
      </div>
      <CommerceMap />
    </section> -->
  </div>
</template>

<style scoped src="@/assets/css/site.css">
</style>


<style>

@import "https://fonts.googleapis.com/css?family=Roboto:300,400&display=swap";
@import "https://fonts.googleapis.com/css?family=Nunito:400,600&display=swap";

.color-primary.nunito {
  color: #ff4940 !important;
}

#dropdown-quepuedo__BV_toggle_ {
  color: rgb(96, 96, 96) !important;
  background-color: transparent !important;
  font-size: 15px !important;
}

#selectCategorias {
  color: rgb(108, 117, 125) !important;
  font-family: Roboto, sans-serif !important;
  font-size: 16px !important;
  border-bottom-color: rgb(108, 117, 125) !important;
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-style: solid !important;
  border-bottom-width: 1px !important;
  border-image-outset: 0px !important;
  border-left-color: rgb(108, 117, 125) !important;
  border-left-style: solid !important;
  border-left-width: 1px !important;
  border-right-color: rgb(108, 117, 125) !important;
  border-right-style: solid !important;
  border-right-width: 1px !important;
  border-top-color: rgb(108, 117, 125) !important;
  border-top-left-radius: 4px !important;
  border-top-right-radius: 0px !important;
  border-top-style: solid !important;
  border-top-width: 1px !important;
}

#selectCategorias option:hover {
  background-color: rgb(108, 117, 125) !important;
}
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";

import $ from "jquery";

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import KitsCombo from "@/components/KitsCombo";
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";

import CommerceMap from "@/components/CommerceMap";

export default {
  components: { CommerceMap, KitsCombo },
  data() {
    return {
      categorias: [],
      CategoriaID: null
    };
  },
  methods: {
    listaClicked() {
      if (this.CategoriaID == null) {
        alert("Debe seleccionar una categoría");
        return;
      }

      let context = this;

      this.$router.push({
        name: "empresas",
        params: { CategoriaID: context.CategoriaID }
      });
    }
  },
  beforeMount: function() {
    // let context = this;
    // axiosHelpers.axiosGet(
    //   "BillPayment/GetCobroExpressCategories",
    //   { All: false },
    //   this,
    //   function(data) {
    //     context.categorias = data.ResponseVM;
    //   }
    // );
  },
  mounted: function() {
    var topMenuHeight = $("#mainNav").outerHeight()+1;

    $(".scroll-link").bind("click", function(e) {
      var href = $(this).attr("href");
      var offsetTop =
        href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: offsetTop
          },
          850
        );

      e.preventDefault();
    });

    var speed = 1000;

    // check for hash and if div exist... scroll to div
    var hash = window.location.hash;

    if ($(hash).length) {
      var offSet = 0;
      var obj = $(hash).offset();
      var targetOffset = obj.top - offSet;
      $("html,body").animate({ scrollTop: targetOffset }, speed);
    }
  }
};
</script>